// GENERATED by scripts/build-solution-table.mjs — do not edit by hand.
// Module 83 (WP-83.5b): the stored routes of every RAMP puzzle on every track
// (Beginner/Intermediate/Expert ramp lengths from generation.json), keyed by `effectiveLevel:variant` → [signatureHash(layoutSignature), moves]. A move is
// `<blockId><U|D|L|R>`. Looked up in `generateFreeLevel` before any search; the
// signature must match the generated board or the entry is ignored.
export const SOLUTION_TABLE = {
    '1:0': ['308b9619', 'b0D b1R b1D b2D b2L'], // beginner 1
    '2:0': ['e116957f', 'b0D b3D b1D b1R b2D b2R'], // beginner 2
    '3:0': ['8183897a', 'b3L b0U b0L b1U b1R b2R b2D b4U b4R'], // beginner 3
    '4:0': ['d9d6593c', 'b1R b2D b2R b4D b4R b4U b3U b3L b0U b0L'], // beginner 4
    '5:0': ['fe2fc9f3', 'b1R b3R b4U b4R b0U b0R b2L'], // beginner 5
    '6:0': ['692701e4', 'b0L b5L b2U b4R b3L b4D b0R b0D b1U b1R b3U'], // beginner 6
    '7:0': ['28d2c3f9', 'b0D b1U b2R b2U b3U b3L'], // beginner 7
    '8:0': ['7dd3dcb0', 'b0R b1R b2R b2D b3D b3L b4D b4R b5R b5D'], // beginner 8
    '9:0': ['6feea421', 'b3U b4L b1D b1R b2R b0U b5D b0L b5R'], // beginner 9
    '10:0': ['fc80c672', 'b0U b2R b5R b1L b3D b1U b1R b4L b4U'], // beginner 10
    '11:0': ['6cd4e58a', 'b5U b2D b4L b0L b1R b1U b3D b3R b2D'], // beginner 11
    '12:0': ['78ced260', 'b3L b0D b1R b2U b2R b5L b6U b6R b0U b0L b0D b4R b4U'], // beginner 12
    '13:0': ['7053f237', 'b2R b1D b5L b4U b2U b1R b0D b0L b3L b3U b4L b6D'], // beginner 13
    '14:0': ['e36edf6d', 'b3L b4L b0D b1U b0L b1R b1D b2U b2R'], // beginner 14
    '15:0': ['d5e74258', 'b0R b2U b1L b5D b2L b6L b3U b4L b5R b6D'], // beginner 15
    '16:0': ['eee2106c', 'b6R b3D b1L b2R b1U b4U b5L b2D b4R b6U b6R b0L b0U'], // beginner 16
    '17:0': ['4a4b305b', 'b1U b5L b6L b6U b3U b4D b3L b4U b4R b0L b0D b2U b2R'], // beginner 17
    '18:0': ['0c58264c', 'b2R b4U b0R b3L b3D b5R b5U b6D b1R'], // beginner 18
    '19:0': ['d04b412c', 'b1L b5L b2U b2L b6D b4R b2D b7D b0L b3U b3L b4R'], // beginner 19
    '20:0': ['dffc09a8', 'b0U b3D b7L b2U b5L b5U b5L b6R b1D b1R b7D b4L b7R b7U'], // beginner 20
    '21:0': ['d4d1c902', 'b3R b1D b4U b5D b2R b5L b0D b0L'], // beginner 21
    '22:0': ['0b432d9e', 'b4R b7U b0L b5U b2U b0U b1L b3U b5R b6D b6L b0D b3L b0R b0U'], // beginner 22
    '23:0': ['38335df0', 'b4U b3R b5D b2L b1D b6D b7D b7L b4D b4L b0D b5D b5R'], // beginner 23
    '24:0': ['4c2f8b41', 'b3R b2L b1D b5R b5U b2U b2R b4U b1L b6D b0R b6L b7D b4R'], // beginner 24
    '25:0': ['d2830c30', 'b6R b2U b1U b3U b0D b5D b5L b5D b7U b8L b4D b4L b7R b6R b1R'], // beginner 25
    '26:0': ['0125194b', 'b1R b4U b5R b0U b6U b6L b3L b3U b7L b3D b2L b7D b3U b3R'], // intermediate 1
    '27:0': ['4ccec3a5', 'b7D b5U b2L b1R b0D b5D b3D b6L b4U b5R b3D b5U b1L b1D'], // intermediate 2
    '28:0': ['78d6726f', 'b1U b2D b2R b4D b0L b0D b5R b3D b0L b6U b6L b0U b5U b5L b6U b6R'], // intermediate 3
    '29:0': ['13552b6a', 'b6R b1R b7R b0L b2D b3L b4U b3U b5L'], // intermediate 4
    '30:0': ['7401ce94', 'b3L b6D b5D b4D b5U b0L b1D b4D b2L b3U b1R b1U b4D'], // intermediate 5
    '31:0': ['badb23d1', 'b0L b3L b3D b4L b7U b1R b7D b7L b6R b6D b2D b2L b3R b3U b5D b5L'], // intermediate 6
    '32:0': ['5ff466e0', 'b2R b7D b3U b6U b0D b3R b4U b5U b4L b1L b0D b5U b1U b5D b5R'], // intermediate 7
    '33:0': ['f029e9a7', 'b4L b0R b6D b1L b7L b3U b0R b2D b2L b3L b5R b2D b5U b6R b6U'], // intermediate 8
    '34:0': ['19f5d0f3', 'b3D b7R b7U b1L b2D b0R b6R b6D b0D b4R b1U b1R b5U b5R b0R b5D'], // intermediate 9
    '35:0': ['e5b4e681', 'b2D b2R b5D b3L b0D b6D b7R b6R b4D b5U b5L b1R b1D b7R b7D'], // intermediate 10
    '36:0': ['d6b2f256', 'b2D b7D b5D b3D b4D b1L b0U b4R b5R b6D b1L b4U b6U b6R b3U b7U'], // intermediate 11
    '37:0': ['73172702', 'b5R b3R b2U b4D b4L b2D b2R b0L b6U b6L b4R b4U b4R b1L b3D b1U b1R'], // intermediate 12
    '38:0': ['2df48b62', 'b7R b3U b5L b4U b2R b0D b6D b7L b1D b5L b6R b1U b2L b2U b6D b6L'], // intermediate 13
    '39:0': ['79764e0b', 'b2D b1L b4L b6L b5U b0R b6D b3R b6R'], // intermediate 14
    '40:0': ['f0f69eac', 'b5L b6U b0L b2L b1D b1R b4L b3U b0R b0U b4D b4R'], // intermediate 15
    '41:0': ['a2bb2d5f', 'b4L b7L b6D b2U b5L b5U b0L b1D b8R b7R b3D b2R b2U b7D b9D b9R'], // intermediate 16
    '42:0': ['534e8431', 'b4D b7D b2R b6U b2L b5U b5R b1U b3L b5R b1D b1R b0D b2R b0U b0L'], // intermediate 17
    '43:0': [
        '5aed6aa7',
        'b9L b4L b7D b6R b0R b5D b8L b8U b0D b0R b2L b3U b9L b9U b1U b5R b4U b4L b1D b1R',
    ], // intermediate 18
    '44:0': ['54d3b235', 'b1L b4L b2D b8D b5L b8R b0L b0U b3D b3R b0D b7L b6L b0L b0U b7L b9D b9L'], // intermediate 19
    '45:0': [
        '7485937d',
        'b1R b5U b9R b8D b2R b0D b7D b7R b6L b3L b6D b5L b5D b4L b2U b4U b8U b3R b3D',
    ], // intermediate 20
    '46:0': [
        'c7b385ba',
        'b4R b2D b5U b6R b8R b8D b8R b3D b7L b7D b1U b1R b0U b3R b9D b9L b6R b6U b1L b1D',
    ], // intermediate 21
    '47:0': ['5d6881d5', 'b2D b4L b3L b6L b1D b6R b6U b4R b5L b8U b0R b7D b7R b5D b8L b5U b8D'], // intermediate 22
    '48:0': [
        '5e0f2969',
        'b8L b7L b2U b0R b6U b4U b6R b3D b8D b7L b2L b5U b1L b2R b2D b4R b4U b4L b8R b8D b1R b3D b1L b1U',
    ], // intermediate 23
    '49:0': ['a09a5cc7', 'b1L b3D b6R b0R b0D b2R b7U b4L b4D b5U b5L b1U b1L b2L b1U b1R'], // intermediate 24
    '50:0': [
        '1ac3dba9',
        'b5R b7L b2U b4R b4U b7R b0U b1U b3L b6L b7L b7D b8R b7D b1R b1D b1L b8R b0D b8U',
    ], // intermediate 25
    '51:0': [
        '0501f425',
        'b0U b1R b7R b7D b4L b7R b5U b6L b5R b3D b2L b0D b0L b2U b2R b5U b5R b0L b0U',
    ], // intermediate 26
    '52:0': [
        '2459039b',
        'b1U b8U b4L b0L b8L b0D b7L b6D b3D b7R b6U b7U b5D b5L b6U b0R b0U b0L b1D b2L b1U b1R',
    ], // intermediate 27
    '53:0': [
        '5ab83ed3',
        'b1U b8D b0R b3L b0U b3D b6U b6R b9L b8L b9U b5U b7U b7L b4U b2L b8R b8D b8L b4R',
    ], // intermediate 28
    '54:0': [
        '7eabc6d1',
        'b3L b3D b2R b4R b1R b2L b7D b8L b0D b0L b0D b4U b5R b0U b6R b5L b4U b5R b0U',
    ], // intermediate 29
    '55:0': [
        '4043498b',
        'b6U b3U b1L b2U b8U b0L b9U b5U b7L b6R b6D b4L b7U b5R b7L b0U b4L b0D b0R b7U b7L',
    ], // intermediate 30
    '56:0': ['4aab08d4', 'b1R b8D b7U b7R b2D b4R b3U b0L b5R b6R b2D b2L b3L b3D'], // intermediate 31
    '57:0': [
        '629ba544',
        'b3D b2D b6R b0U b5U b7L b2L b3U b9R b9U b4R b5D b1D b0R b1R b2U b8U b4D b1D b1L b4L b1U',
    ], // intermediate 32
    '58:0': [
        'a156549d',
        'b3U b0L b6D b0L b7U b1L b8R b4D b1U b2R b8R b8D b8L b0D b1L b0D b1U b1R b5L',
    ], // intermediate 33
    '59:0': ['a03efa79', 'b0D b8R b4U b1R b5U b7D b2D b7U b3R b6D b6L b9D b7L b9R b1L b1D b8R b8D'], // intermediate 34
    '60:0': [
        'e5397abe',
        'b4U b1L b2L b9D b3L b7L b0D b6R b6D b8R b5U b8D b3U b2R b3L b3D b3R b2R b7U b3D b3L',
    ], // intermediate 35
    '61:0': [
        '0e2eda97',
        'b8L b5U b7R b6U b9D b6L b2D b5D b4R b1D b3D b8L b6D b9L b1D b2U b2L b5U b1R b0U b10L b5D b10R b6D b10U b6U b6R',
    ], // expert 1
    '62:0': [
        '5fae642f',
        'b6R b9R b0U b8U b2L b4L b1D b3L b7D b6D b9R b8R b3U b6L b8D b3R b5D b4R b4U b2R b5U',
    ], // expert 2
    '63:0': [
        'bba306ad',
        'b6L b4U b0R b3D b6L b7R b0U b0L b3R b1U b2R b5R b5U b1L b1D b2D b8R b1U b1R',
    ], // expert 3
    '64:0': [
        'bf449075',
        'b2R b0U b4D b1D b7U b9R b7D b3R b4U b4R b8U b3L b3U b9L b8R b6L b5D b6U b6R b10U b10L',
    ], // expert 4
    '65:0': [
        '5b5840b5',
        'b4R b2D b3D b3L b9D b0L b7L b1L b5L b7U b4L b6U b4R b8R b9R b1R b3R b1L b6D b8L b6L b1L b6U b6L',
    ], // expert 5
    '66:0': [
        '26003684',
        'b2R b8U b8R b6D b0D b5D b9R b3R b4U b1U b1L b7L b7U b10L b10U b6D b6L b0L b5D b3R b0D b0R',
    ], // expert 6
    '67:0': [
        '487925b7',
        'b3L b5D b4D b1R b7R b1R b0U b0L b2R b6U b2U b8U b3U b4L b4U b5L b1D b3R b8D b2L b3U b2D b2R',
    ], // expert 7
    '68:0': ['93d2a3d9', 'b4D b8U b7R b3L b3U b6L b5L b0L b1D b8U b2U b0R b5U b0L b0D'], // expert 8
    '69:0': [
        'a065589a',
        'b0R b6R b6D b4R b10U b1D b9D b4L b8U b5U b4U b7L b3D b3L b2D b8R b10U b8D b8L b4R b5U b5R b4U b4L',
    ], // expert 9
    '70:0': [
        'f99416d5',
        'b5U b6R b1U b0R b5L b5U b2L b4D b1L b0U b7L b7U b2R b2U b8R b3L b2D b3L b2R b4D b4R',
    ], // expert 10
    '71:0': ['a41d74de', 'b2U b3R b1D b6L b8U b9R b9D b4U b0U b0L b7L b7D b3U b5L b3D b3R b9D'], // expert 11
    '72:0': [
        'fa7c1bdd',
        'b6U b5U b2U b8R b8U b5U b3R b9U b9R b4D b7R b0U b1D b4L b7D b1L b5D b5L b1D b1R',
    ], // expert 12
    '73:0': [
        '9ca4d39f',
        'b4D b1R b8R b3D b1L b2D b7D b7R b0L b1R b9L b9D b6L b5U b5L b1R b1U b7U b7R',
    ], // expert 13
    '74:0': ['e9236820', 'b5D b0L b7L b4D b8L b3L b2U b1R b6D b2L b7U b6L b4L b5U b7R b4U b7D'], // expert 14
    '75:0': [
        '64ab265c',
        'b3D b6L b2D b6U b1R b0U b9R b8R b5D b9U b7L b4D b4R b9D b1L b9U b1L b9D b9R',
    ], // expert 15
    '76:0': [
        'e03b2a5a',
        'b1L b8U b0U b5D b2L b5U b6D b7D b5R b6R b7L b4U b10U b10R b6U b3R b9R b9U b7L b7D b6L b6D',
    ], // expert 16
    '77:0': [
        'bccb4ea8',
        'b3D b7U b5L b1U b2L b0D b1R b1U b6D b7R b8D b4R b7U b8U b2U b8L b8D b2R b4R b2L b5R',
    ], // expert 17
    '78:0': [
        '3575c4ea',
        'b3R b7L b0D b8R b8D b7U b7R b0D b2R b6R b6D b7R b9D b1R b5U b4R b5D b7U b4L b4U',
    ], // expert 18
    '79:0': [
        '02a1f940',
        'b5L b8D b0U b1R b7R b7D b6L b9R b9U b0D b10R b4D b4R b2D b6L b3R b3U b0R b2D b0U b0L',
    ], // expert 19
    '80:0': [
        '7b6118b4',
        'b3U b7L b5D b4D b0R b3U b1L b1D b6D b6R b4L b1L b8D b2R b5L b2D b0R b0D b9L b0L b10U b4U b4R b0R b1U b5U b0U b5R b5U b1D b1L',
    ], // expert 20
    '81:0': [
        '826d2351',
        'b4U b8U b7R b6U b5D b0L b2U b0R b3R b4R b3D b0L b3D b9D b7R b0U b1U b1R b4U b4L b5L b5U',
    ], // expert 21
    '82:0': [
        '241a58cb',
        'b6R b0D b9U b4D b4L b2U b7L b8L b0U b0R b3L b5L b1L b8U b4L b3R b1D b3R b1L b1U',
    ], // expert 22
    '83:0': ['e6327aa6', 'b2L b4L b5D b0D b6D b1D b2R b8U b9U b7R b3U b3R b1U b5L b1R b1D b7R'], // expert 23
    '84:0': [
        '7e372af1',
        'b6R b4D b6L b6U b5L b2L b8L b8U b1R b1D b5U b1L b3D b7D b5R b9D b0R b6R b9R',
    ], // expert 24
    '85:0': [
        '1a1c9f16',
        'b9U b8L b2D b8R b8U b1U b3U b10L b7D b7L b3D b4D b6D b9R b5R b1R b4R b6R b3U b6D b4L b1L b4D b1D b5L b0D b9U b9L',
    ], // expert 25
    '86:0': [
        '7a4324d9',
        'b6R b4R b9R b9U b7U b5U b4L b4D b4L b4D b1L b5R b3U b5L b0U b2L b5D b5R b2U b0D b8L b0U b8L b0R',
    ], // expert 26
    '87:0': ['579bd8ea', 'b8R b5R b6R b1D b4R b7U b0L b2U b6U b6L b7D b3U b5L b3L b3U b4D'], // expert 27
    '88:0': ['479e16fb', 'b8R b6L b7U b4R b7L b2D b9U b5U b0L b1D b7R b0D b3D b7U b8D b9D b9L'], // expert 28
    '89:0': ['122c7c6e', 'b1D b8L b3U b0R b4U b7R b1R b1D b2D b6R b6D b2U b2R b5U b5R b2L'], // expert 29
    '90:0': [
        'c51da9fb',
        'b1R b3D b3L b7D b7R b6D b6L b9D b9L b0D b0L b5D b5L b8D b2R b2D b4R b10R b2L b5U',
    ], // expert 30
    '91:0': [
        '479d5f00',
        'b8D b2R b7U b8L b9D b3R b5D b1R b6L b6U b4D b8R b2R b0D b8U b0R b8D b0L b0D b1U b1L',
    ], // expert 31
    '92:0': [
        '0022ee16',
        'b0D b9L b1R b4U b6R b0R b1L b0D b3L b1R b1U b7U b2U b5R b7R b5R b8L b8U b7U b7R',
    ], // expert 32
    '93:0': [
        'e3ee1f3e',
        'b1L b8R b7U b7L b4R b5U b9D b5L b4U b6R b6U b9U b0R b2U b3L b2D b2R b9D b9L',
    ], // expert 33
    '94:0': [
        '1ea3a604',
        'b8R b8U b2R b3U b0R b1U b4U b5L b7L b7U b0L b6R b3D b4L b0R b6L b6U b6R b6D b3D',
    ], // expert 34
    '95:0': [
        '1852c725',
        'b9U b10R b10D b8R b3U b8D b3R b0U b0R b2L b5L b10L b8D b6L b2R b2D b5U b10U b1L b7L b4U b7D b7L b10R b5D b5R',
    ], // expert 35
    '96:0': ['7a662ac5', 'b3R b3D b6U b2L b4D b8D b6L b0D b7D b5D b1L b7U b6D b6R'], // expert 36
    '97:0': [
        '51976da5',
        'b9D b2L b8L b1D b7R b8D b3R b3U b5D b0R b6D b6R b5D b5L b2R b4U b2D b2L b9U b9R',
    ], // expert 37
    '98:0': [
        '9d32c47d',
        'b7L b6D b4R b7U b1U b3U b2R b8L b0D b0R b2D b5R b8U b9L b6L b6D b6R b3L b3D b2U b5R b2L b2D',
    ], // expert 38
    '99:0': [
        '55a60f85',
        'b4R b5U b3U b9L b0L b8U b1L b6L b6U b8D b8R b7L b7D b5L b9U b2L b5R b9L b5U',
    ], // expert 39
    '100:0': [
        '0cc3c55c',
        'b5D b4U b2R b7R b6D b3D b1L b3U b0L b8D b8R b3R b0U b6U b7L b7U b3L b4D b3D b4L b3R',
    ], // expert 40
    '101:0': [
        'f3ac199f',
        'b9D b9L b1D b1R b7U b4L b1D b11D b3D b5U b8R b10D b10R b10D b2R b5R b6U b0U b5L b7U b5R b4L b10L b3L b3U b5D b5R b7R b7D',
    ], // expert 41
    '102:0': [
        '46fd412c',
        'b2D b11U b10U b6R b1D b9U b6L b3U b5R b8R b6D b0R b3L b10D b11R b11D b4R b3U b4D b3R b7L b7D b0U b5R b4D b5R b0L b0D b4R b8D b8R',
    ], // expert 42
    '103:0': [
        '732e6b0c',
        'b3R b1L b6D b7U b7L b11R b0L b11U b4L b9U b2L b10D b8L b9R b5U b0U b2U b3R b2L b9D b8R b6R b0D b0R b8D b8L b4L b2L b2D b4D b4R',
    ], // expert 43
    '104:0': [
        'f50813e2',
        'b10U b8D b4L b3U b5U b8R b9R b9D b2R b1D b4L b5L b9U b7U b1R b6R b1U b0L b7U b11U b1U b0R b11U b11L',
    ], // expert 44
    '105:0': [
        '866a7e37',
        'b2L b3L b5D b9U b6R b0R b7U b0U b6R b9D b8D b4L b8R b8D b1U b2U b2L b1U b7U b7L b2D b2R',
    ], // expert 45
    '106:0': [
        'a2201a0e',
        'b8D b3R b7R b11D b5R b7D b9U b9R b5D b2D b2R b0U b4L b5U b1L b6L b6U b10L b10U b7L b7U b5D b5L b2D',
    ], // expert 46
    '107:0': [
        'b24a82d5',
        'b8U b2R b6U b11L b10D b8R b1D b8U b1R b9D b3D b0R b3L b4R b5U b5R b6U b6R b11U b11R b1L b4U b1U b7L b7U b4D b4R',
    ], // expert 47
    '108:0': [
        'af85b5c5',
        'b11U b6L b7U b9R b6D b7L b0D b5D b3R b0L b6R b1R b7R b2D b1L b10R b1U b7L b7U b5L b3D b8D b4R b5U b8L',
    ], // expert 48
    '109:0': [
        '76d5ebfe',
        'b8L b1R b10D b4L b2D b6D b0D b3R b9D b9R b7D b11R b5U b5R b0R b4R b4U b10R b10U b7R b7D',
    ], // expert 49
    '110:0': [
        '651fc57a',
        'b7L b2U b3R b9R b6D b6L b11R b5R b5U b7U b7R b4L b0R b8R b10U b8L b0L b0D b1R b7D b0L b8R',
    ], // expert 50
    '111:0': [
        'e184cf67',
        'b7L b3R b0U b1U b6U b3L b3D b5L b2U b4L b8U b9L b9U b4R b5R b10D b10R b11R b11U b9L b9D',
    ], // expert 51
    '112:0': ['92dd340a', 'b2D b3U b8L b9U b4R b5R b0U b4L b6D b0D b0R b7L b1U b1L b4U b4R'], // expert 52
    '113:0': [
        '78bb19d5',
        'b4R b10D b8L b6U b6R b3U b3L b0U b1R b5R b11U b9D b9R b2U b7R b9L b2L b10D b8D b9U b10R',
    ], // expert 53
    '114:0': [
        '22d04272',
        'b2U b7R b1R b3L b11U b4R b10R b0D b5L b0L b6D b5D b8R b8U b11R b3D b11U b5U b5R b9L b9U',
    ], // expert 54
    '115:0': [
        '043e6c08',
        'b5L b11U b11L b1U b3R b9U b9R b10L b1R b7U b4L b6L b8U b2L b0D b0L b4R b2U b2R b10R b10U b6D b6R',
    ], // expert 55
    '116:0': [
        'dba44c58',
        'b9D b4D b5R b6U b8D b0D b7R b10R b6R b0U b4L b0U b1U b9L b8D b4U b2R b1D b1R b3U b4L b4D b10L b1L b9U b9L b11R b11U b1D b1R b7D b7L',
    ], // expert 56
    '117:0': [
        '1721610d',
        'b5D b5L b3D b0L b4L b6U b11L b2U b8R b9D b9L b5D b5R b2D b10R b2R b7D b0L b1D b6L b10U b6R b10U b6L b6D',
    ], // expert 57
    '118:0': [
        'd33f03a6',
        'b2D b6U b8D b5L b10D b0U b4L b7U b0R b5U b7R b3L b4R b4D b5R b9L b9D b5D b1R b3U b11R b3L b9U b1R b9D b3D b9L b9U',
    ], // expert 58
    '119:0': ['714f78c2', 'b8L b5U b5R b1U b6D b2L b8D b9U b3L b0U b9L b4U b9D b4L b6U b6R b7U'], // expert 59
    '120:0': [
        '3aed429e',
        'b3L b2R b8U b1D b5R b5U b0R b6R b3U b6U b7D b7R b10L b8D b11R b11D b9U b10U b3L b3U b2D b4L b11U b2L b11R',
    ], // expert 60
};
